import { createTheme } from '@mui/material'

export const THEME = {
  colors: {
    primary: '#FFEB01',
    secondary: '#23231F',
    background: '#23231F',
    background2: 'rgba(36, 37, 41, 1)',
    backgroundHover: 'rgba(54, 53, 56, 1)',
    tertiary: '#37393F',
    disabled: '#676767',
    error: '#E91B1B',
    warning: '#ed6c02',
    success: '#43FF01',
    text: '#ffffff',
  },
}

export const MuiTheme = createTheme({
  typography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
  },
  palette: {
    primary: { main: THEME.colors.primary },
    secondary: { main: THEME.colors.secondary },
    text: {
      primary: '#fff',
      disabled: THEME.colors.disabled,
      secondary: THEME.colors.tertiary,
    },
    background: {
      default: THEME.colors.background,
    },
  },
  components: {
    MuiTable: {
      styleOverrides: {
        root: {
          background: '#37393F',
          borderRadius: 12,
          overflow: 'hidden',
        },
      },
    },
    MuiPaper: {
      styleOverrides: { root: { background: THEME.colors.backgroundHover } },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    MuiButton: {
      defaultProps: { variant: 'contained' },
      styleOverrides: {
        root: { borderRadius: 8, gap: 8, fontWeight: 'normal' },
        outlined: { background: THEME.colors.backgroundHover },
      },
    },
    MuiIcon: {
      styleOverrides: {
        root: { fontWeight: 'inherit' },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined' },
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': { borderRadius: 8, overflow: 'hidden' },
          margin: 0,
          width: '100%',
          '& label': { color: '#bcbcbc' },
          '& .MuiFormHelperText-root': { color: '#bcbcbc' },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          background: 'transparent',
          border: '1px solid',
          fontWeight: 400,
        },
        standardError: {
          borderColor: THEME.colors.error,
          color: THEME.colors.error,
        },
        standardWarning: {
          borderColor: THEME.colors.warning,
          color: 'white',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: THEME.colors.disabled,
          },
        },
      },
    },
    MuiContainer: { styleOverrides: { root: { padding: 0, margin: 0 } } },
  },
})
